import { useEffect, useState } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';

// Approximate scroll position where Vault content becomes visible
const SCROLL_DEPTH_THRESHOLD = 300;

export default function useTrackVaultRendered() {
  const { vaultDataAvailable, vaultDataMapped, narratives } =
    useGetVehicleDetails();
  const {
    VaultWhyBuyNarrativeConfig: {
      bucket: { treatment: treatmentVersion = '' } = {}
    } = {}
  } = useConfiguration();
  const { narrativeVersion } = useGetVaultWhyBuyNarrative();

  const hasVaultDataAvailable = vaultDataAvailable ?? false;
  const wasVaultDataMapped = vaultDataMapped ?? false;
  const hasTreatmentWhyBuy = Boolean(
    treatmentVersion &&
      narratives?.some(
        narrative => narrative?.narrativeVersion === treatmentVersion
      )
  );

  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (hasScrolled) return;

    const handleScroll = () => {
      if (window.scrollY >= SCROLL_DEPTH_THRESHOLD) setHasScrolled(true);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  useTrackRendered(
    'car-merch-ui-vdp-vault-why-buys-hotswap',
    hasScrolled && (hasVaultDataAvailable || hasTreatmentWhyBuy),
    {
      availableWhyBuyNarratives:
        narratives?.map(narrative => ({
          narrativeType: narrative?.narrativeType,
          narrativeVersion: narrative?.narrativeVersion
        })) ?? [],
      hasTreatmentWhyBuy,
      hasVaultDataAvailable,
      wasVaultDataMapped,
      whyBuyVersionShown: narrativeVersion ?? 'ymmt'
    }
  );
}
